module.exports = __webpack_public_path__ + "img/26.05880626.jpg";